import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import JitsiMeetJS from '../../../base/lib-jitsi-meet/_.web';
import { isLocalTrackMuted } from '../../../base/tracks/functions.any';
import { MEDIA_TYPE } from '../../../base/media/constants';
const JitsiTrackEvents = JitsiMeetJS.events.track;
const useStyles = makeStyles()(() => ({
    audioIndicator: {
        position: 'absolute',
        left: '24px',
        bottom: '16px',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        background: '#0376DA',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2px',
        zIndex: 10,
        '@media (max-width: 768px)': {
            left: '12px',
            bottom: '16px',
        },
    },
    bar: {
        width: '3px',
        borderRadius: '2px',
        background: '#fff',
        transition: 'height 0.1s ease',
    },
}));
/**
 * Component that displays a blue circular audio indicator with 3 vertical bars
 * that react to audio levels. Only shown when microphone is unmuted.
 */
const PrejoinAudioIndicator = ({ audioTrack }) => {
    const { classes } = useStyles();
    const [audioLevel, setAudioLevel] = useState(0);
    const [heights, setHeights] = useState([6, 10, 6]);
    // Use Redux state to track mute status - this is more reliable
    const isAudioMuted = useSelector((state) => isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.AUDIO));
    useEffect(() => {
        if (!audioTrack) {
            return;
        }
        const handleAudioLevelChange = (level) => {
            setAudioLevel(level);
        };
        audioTrack.on(JitsiTrackEvents.TRACK_AUDIO_LEVEL_CHANGED, handleAudioLevelChange);
        return () => {
            audioTrack.off(JitsiTrackEvents.TRACK_AUDIO_LEVEL_CHANGED, handleAudioLevelChange);
        };
    }, [audioTrack]);
    useEffect(() => {
        if (audioLevel > 0.01 && !isAudioMuted) {
            // Animate bars based on audio level
            const interval = setInterval(() => {
                const base1 = 4 + Math.random() * audioLevel * 8;
                const base2 = 6 + Math.random() * audioLevel * 10;
                const base3 = 4 + Math.random() * audioLevel * 8;
                setHeights([base1, base2, base3]);
            }, 100);
            return () => clearInterval(interval);
        }
        else {
            setHeights([6, 10, 6]);
        }
    }, [audioLevel, isAudioMuted]);
    // Don't show indicator if no audio track or if muted
    if (!audioTrack || isAudioMuted) {
        return null;
    }
    return (React.createElement("div", { className: classes.audioIndicator },
        React.createElement("div", { className: classes.bar, style: { height: `${heights[0]}px` } }),
        React.createElement("div", { className: classes.bar, style: { height: `${heights[1]}px` } }),
        React.createElement("div", { className: classes.bar, style: { height: `${heights[2]}px` } })));
};
export default PrejoinAudioIndicator;
